<template>
  <div class="attr-wrap" v-loading="loading" ref="main">
    <div class="scroll" ref="content">
      <div class="slider-wrap">
        <span class="label-name">归因回溯窗口期：</span>
        <el-slider class="slider" v-model="expires" :marks="marks" :max="30"></el-slider>
        <span class="show-data">{{ expires ? expires + "天" : "-" }}</span>
      </div>
      <span class="tip-wrap">激活归因LastClick的最初回溯天数</span>

      <div class="slider-wrap" style="margin-top: 24px">
        <span class="label-name">重归因窗口期：</span>
        <el-select v-model="resetExpires" placeholder="请选择">
          <el-option label="30天" :value="30"> </el-option>
          <el-option label="60天" :value="60"> </el-option>
          <el-option label="90天" :value="90"> </el-option>
        </el-select>
      </div>
      <span class="tip-wrap bottom-wrap">窗口期过后老用户可重新进行归因</span>
      <div class="h2-title">链接参数</div>
      <ul class="data-list">
        <li class="data-item">
          <span class="header-text">参数名称:</span>
          <span class="header-text">值:</span>
        </li>
        <li class="data-item" v-for="item of confList" :key="item.key">
          <el-select class="select-item" v-model="item.value" placeholder="请选择参数名称" @change="(value) => changeLabel(value, item)">
            <el-option
              v-for="confItem of selectConf"
              :key="confItem.value"
              :label="confItem.label"
              :value="confItem.value"
              :disabled="confItem.disabled"
            >
            </el-option>
          </el-select>
          <el-input class="select-item select-value" v-model="item.value" placeholder="请选择参数名称" :disabled="true"></el-input>
          <i class="del-icon el-icon-delete" @click="delConf(item.key)"></i>
        </li>
      </ul>
    </div>
    <div class="footer">
      <el-button class="add-btn" icon="el-icon-plus" plain @click="addConf">新增参数</el-button>
      <div class="btn-wrap">
        <el-button class="btn-item" type="primary" @click="saveData">保 存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { queryConvertPara, saveConvertPara } from "@/api/tools.js";
import { allSelectConf } from "./selectConf.js";
export default {
  name: "AttrConf",
  props: ["params"],
  data() {
    return {
      expires: 3,
      confList: [],
      marks: {
        7: "7",
        30: {
          style: {
            "white-space": "nowrap",
          },
          label: "30",
        },
      },
      loading: false,
      resetExpires: null,
    };
  },
  methods: {
    addConf() {
      this.confList.push({ label: null, value: null, key: Math.random() });
      this.$nextTick(() => {
        this.$refs.content.scrollTop = this.$refs.content.scrollHeight - 676;
      });
    },
    delConf(key) {
      let delIndex = this.confList.findIndex((item) => item.key === key);
      if (key !== -1) {
        this.confList.splice(delIndex, 1);
      }
    },
    changeLabel(value, item) {
      item.value = value;
    },
    searchData(data) {
      this.confList = [];
      this.loading = true;
      queryConvertPara({
        platType: data.curPlatType,
        pkg: data.pkg,
      }).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.expires = res.convertPara ? res.convertPara.expires : 3;
          this.resetExpires = res.convertPara && res.convertPara.resetExpires ? res.convertPara.resetExpires : 90;
          if (res.convertPara && res.convertPara.convertData) {
            this.confList = res.convertPara.convertData.split("&").map((str) => {
              let [key, value] = str.split("=");
              return {
                label: key,
                value: value,
                key: Math.random(),
              };
            });
          } else {
            this.confList = allSelectConf[this.params.curPlatType].map((item) => {
              return {
                label: item.label,
                value: item.value,
                key: Math.random(),
              };
            });
          }
        }
      });
    },
    saveData() {
      let errorData = this.confList.find((item) => !item.value);
      if (errorData) {
        this.$message({
          message: "部分配置项未填写",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      let formatArr = JSON.parse(JSON.stringify(this.confList));
      formatArr.map((item) => {
        let label = this.selectConf.find((conf) => conf.value === item.value).label;
        item.label = label;
        return item;
      });
      let parmas = {
        platType: this.params.curPlatType,
        pkg: this.params.pkg,
        expires: this.expires,
        convertData: formatArr.map((item) => item.label + "=" + item.value).join("&"),
        resetExpires: this.resetExpires,
      };
      saveConvertPara({
        data: JSON.stringify(parmas),
      }).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.$message({
            message: "配置保存成功",
            type: "success",
          });
        }
      });
    },
  },
  computed: {
    selectConf() {
      let platType = this.params.curPlatType;
      if (platType) {
        return allSelectConf[platType].map((item) => {
          item.disabled = this.confList.map((confItem) => confItem.value).includes(item.value);
          return item;
        });
      } else {
        return [];
      }
    },
  },
  watch: {
    params: {
      handler(val) {
        if (val.curPlatType && val.pkg) {
          this.searchData(val);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.attr-wrap {
  padding: 0 0px 16px 24px;
  box-sizing: border-box;
  height: calc(100vh - 195px);
  overflow: hidden;
  .scroll {
    height: calc(100% - 90px);
    overflow: auto;
  }
  .slider-wrap {
    display: flex;
    align-items: center;
    .label-name {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
    }
    .slider {
      width: 600px;
      margin-left: 25px;
      /deep/ .el-slider__button {
        border: 4px solid #409eff;
        box-sizing: border-box;
      }
      /deep/ .el-slider__runway {
        height: 4px;
      }
      /deep/ .el-slider__bar {
        height: 4px;
      }
      /deep/ .el-slider__stop {
        height: 4px;
        width: 4px;
      }
    }
    .show-data {
      font-size: 16px;
      margin-left: 20px;
    }
  }
  .tip-wrap {
    display: block;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    margin-top: 14px;
    &.bottom-wrap {
      padding-bottom: 24px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
    }
  }
  .h2-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 14px;
    padding: 18px 0;
    &::before {
      content: "";
      display: inline-block;
      width: 3px;
      height: 11px;
      border-radius: 10px;
      background: rgba(24, 144, 255, 1);
      margin-right: 6px;
    }
  }
  .data-list {
    padding: 0px;
    margin: 0px;
    list-style: none;
    .data-item {
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      .header-text {
        display: inline-block;
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        width: 230px;
      }
      .select-item {
        width: 190px;
        margin-right: 40px;
        &.select-value {
          margin-right: 12px;
        }
      }
      .del-icon {
        cursor: pointer;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
  .add-btn {
    width: 420px;
    height: 32px;
    color: rgba(24, 144, 255, 1);
    border-color: rgba(24, 144, 255, 1);
    margin-top: 6px;
  }
  .btn-wrap {
    margin-top: 20px;
    text-align: center;
    .btn-item {
      width: 74px;
      height: 32px;
    }
  }
}
</style>
